import React from 'react';
import { Rule } from 'src/helpers/rulesEngine';
import { Link } from 'src/components/Analytics';
import Alert from 'src/components/Alert/';
import { isActive } from 'src/helpers/page';

const UnverifiedDocumentAlert: Rule<JSX.Element> = state => {
  const { verificationStatus, status, name } = state.page;
  const alertKey = 'verify_identity';

  if (isActive({ status }) && verificationStatus === 'UnverifiedDocument') {
    return {
      matched: true,
      result: (
        <Alert id={alertKey} type="red" persistent>
          <p className="jg-space-mbn">
            One last thing!{' '}
            <Link to={`/${name}/dashboard/identity`}>Verify your identity</Link>{' '}
            to make sure donations reach your account.
          </p>
        </Alert>
      ),
    };
  }

  return { matched: false };
};

export default UnverifiedDocumentAlert;



// WEBPACK FOOTER //
// ./src/helpers/alerts/UnverifiedDocumentAlert.tsx